import { clear, el } from "./dom";

export interface ConfirmOptions {
  title: string;
  message: string;
  detail?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
}

let dialog: HTMLDialogElement | null = null;

function ensureDialog(): HTMLDialogElement {
  if (dialog !== null) return dialog;
  const element = el("dialog", { className: "modal" });
  document.body.append(element);
  dialog = element;
  return element;
}

/** Confirmación modal (nativa, accesible): resuelve true solo con el botón de acción. */
export function confirmAction(options: ConfirmOptions): Promise<boolean> {
  const element = ensureDialog();
  if (element.open) element.close();
  clear(element);

  const card = el("div", { className: "modal__card" });
  card.append(
    el("h2", { className: "modal__title", text: options.title }),
    el("p", { className: "modal__message", text: options.message }),
  );
  if (options.detail !== undefined && options.detail !== "") {
    card.append(el("p", { className: "modal__detail", text: options.detail }));
  }

  const actions = el("div", { className: "modal__actions" });
  const cancel = el("button", { className: "btn btn--ghost", text: options.cancelLabel ?? "Cancelar" });
  cancel.type = "button";
  const confirm = el("button", {
    className: options.danger === true ? "btn btn--danger" : "btn btn--primary",
    text: options.confirmLabel ?? "Confirmar",
  });
  confirm.type = "button";
  actions.append(cancel, confirm);
  card.append(actions);
  element.append(card);

  return new Promise<boolean>((resolve) => {
    let result = false;
    let settled = false;
    const finish = (value: boolean): void => {
      if (settled) return;
      settled = true;
      resolve(value);
    };

    cancel.addEventListener("click", () => {
      result = false;
      element.close();
    });
    confirm.addEventListener("click", () => {
      result = true;
      element.close();
    });
    element.addEventListener(
      "close",
      () => finish(result),
      { once: true },
    );
    element.addEventListener("cancel", () => {
      result = false;
    });
    element.addEventListener("click", (event) => {
      if (event.target === element) element.close();
    });

    element.showModal();
    cancel.focus();
  });
}
